import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProductComponentDef } from '@df/catalog-ui/product/product.component.def';
import { ImageModule } from '@df/module-image/image.module';
import { IBasketItemData } from '@df/session/api/basket/basket-item';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { ShellComponent } from '@df/ui/common/shell/shell.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
@Component({
    selector: 'checkout-success-item',
    templateUrl: './checkout-success-item.html',
    standalone: true,
    imports: [SizeClassDirective, ImageModule, PriceComponent, OptionLabelPipe, TranslationModule, ShellComponent, NgClass],
    changeDetection: ChangeDetectionStrategy.Default
})
export class CheckoutSuccessItemComponent extends ProductComponentDef {
    @Input()
    item?: IBasketItemData;

    get image(): string | undefined {
        return this.item?.am_giftcard_image_url || this.model?.data?.image;
    }
}
